// Auto-generated by scripts/fetch-fake-influencers.js. Do not edit by hand.
// Source: randomuser.me (free for any use). Re-run with:
//   node scripts/fetch-fake-influencers.js --force

export const FAKE_INFLUENCERS = [
  {
    "id": "000",
    "photo": "/fake-influencers/000.jpg",
    "name": "Kasper Hietala",
    "handle": "thekasper",
    "followers": 20816,
    "engagement": 6.6,
    "niche": "gaming",
    "verified": true,
    "city": "Taipalsaari",
    "country": "Finland"
  },
  {
    "id": "001",
    "photo": "/fake-influencers/001.jpg",
    "name": "Hélèna Lemaire",
    "handle": "helenalemaire",
    "followers": 7537,
    "engagement": 3.7,
    "niche": "food",
    "verified": false,
    "city": "Reims",
    "country": "France"
  },
  {
    "id": "002",
    "photo": "/fake-influencers/002.jpg",
    "name": "Ann-Kathrin Michl",
    "handle": "annkathrinm",
    "followers": 13856,
    "engagement": 5.2,
    "niche": "travel",
    "verified": false,
    "city": "Creglingen",
    "country": "Germany"
  },
  {
    "id": "003",
    "photo": "/fake-influencers/003.jpg",
    "name": "Emma Konradsen",
    "handle": "emma_konradsen",
    "followers": 6522,
    "engagement": 7.7,
    "niche": "music",
    "verified": false,
    "city": "Lysøysund",
    "country": "Norway"
  },
  {
    "id": "004",
    "photo": "/fake-influencers/004.jpg",
    "name": "Thibaut Deschamps",
    "handle": "thibaut.deschamps",
    "followers": 7724,
    "engagement": 5.5,
    "niche": "fashion",
    "verified": false,
    "city": "Saint-Étienne",
    "country": "France"
  },
  {
    "id": "005",
    "photo": "/fake-influencers/005.jpg",
    "name": "Nolan Chapman",
    "handle": "nolan_chapman",
    "followers": 17606,
    "engagement": 5.9,
    "niche": "fashion",
    "verified": false,
    "city": "Dunboyne",
    "country": "Ireland"
  },
  {
    "id": "006",
    "photo": "/fake-influencers/006.jpg",
    "name": "Greta Fossan",
    "handle": "greta_fossan",
    "followers": 6426,
    "engagement": 7.8,
    "niche": "music",
    "verified": false,
    "city": "Hommelvik",
    "country": "Norway"
  },
  {
    "id": "007",
    "photo": "/fake-influencers/007.jpg",
    "name": "Thomas Walker",
    "handle": "thomasdaily",
    "followers": 6959,
    "engagement": 3.7,
    "niche": "travel",
    "verified": false,
    "city": "Steilacoom",
    "country": "United States"
  },
  {
    "id": "008",
    "photo": "/fake-influencers/008.jpg",
    "name": "Jeremy Denys",
    "handle": "thejeremy",
    "followers": 18413,
    "engagement": 5.7,
    "niche": "gaming",
    "verified": false,
    "city": "Springfield",
    "country": "Canada"
  },
  {
    "id": "009",
    "photo": "/fake-influencers/009.jpg",
    "name": "Kawa Schraa",
    "handle": "kawa62",
    "followers": 10977,
    "engagement": 5.3,
    "niche": "lifestyle",
    "verified": false,
    "city": "Lemmer",
    "country": "Netherlands"
  },
  {
    "id": "010",
    "photo": "/fake-influencers/010.jpg",
    "name": "Daniel Anderson",
    "handle": "daniela",
    "followers": 20200,
    "engagement": 7.6,
    "niche": "travel",
    "verified": false,
    "city": "Waterloo",
    "country": "Canada"
  },
  {
    "id": "011",
    "photo": "/fake-influencers/011.jpg",
    "name": "Adrian Brown",
    "handle": "adriandaily",
    "followers": 17156,
    "engagement": 7.6,
    "niche": "gaming",
    "verified": false,
    "city": "Brisbane",
    "country": "Australia"
  },
  {
    "id": "012",
    "photo": "/fake-influencers/012.jpg",
    "name": "Aleksander Epping",
    "handle": "aleksander_epping",
    "followers": 14208,
    "engagement": 5.6,
    "niche": "lifestyle",
    "verified": false,
    "city": "Hichtum",
    "country": "Netherlands"
  },
  {
    "id": "013",
    "photo": "/fake-influencers/013.jpg",
    "name": "Silvia Ortiz",
    "handle": "silviaortiz",
    "followers": 5870,
    "engagement": 6.6,
    "niche": "lifestyle",
    "verified": false,
    "city": "Lorca",
    "country": "Spain"
  },
  {
    "id": "014",
    "photo": "/fake-influencers/014.jpg",
    "name": "Roberto Fowler",
    "handle": "roberto.fowler",
    "followers": 20479,
    "engagement": 7.5,
    "niche": "music",
    "verified": false,
    "city": "Geraldton",
    "country": "Australia"
  },
  {
    "id": "015",
    "photo": "/fake-influencers/015.jpg",
    "name": "Alexander Méndez",
    "handle": "alexander.mendez",
    "followers": 23692,
    "engagement": 5.1,
    "niche": "gaming",
    "verified": false,
    "city": "Santa Cruz de Tenerife",
    "country": "Spain"
  },
  {
    "id": "016",
    "photo": "/fake-influencers/016.jpg",
    "name": "Jessie Hunter",
    "handle": "jessiedaily",
    "followers": 24766,
    "engagement": 4.5,
    "niche": "food",
    "verified": false,
    "city": "Listowel",
    "country": "Ireland"
  },
  {
    "id": "017",
    "photo": "/fake-influencers/017.jpg",
    "name": "Magnus Christiansen",
    "handle": "magnus.christiansen",
    "followers": 5660,
    "engagement": 3.4,
    "niche": "music",
    "verified": false,
    "city": "Stoevring",
    "country": "Denmark"
  },
  {
    "id": "018",
    "photo": "/fake-influencers/018.jpg",
    "name": "Johanne Jensen",
    "handle": "johanne84",
    "followers": 10117,
    "engagement": 6.1,
    "niche": "gaming",
    "verified": false,
    "city": "Beder",
    "country": "Denmark"
  },
  {
    "id": "019",
    "photo": "/fake-influencers/019.jpg",
    "name": "Milla Hannula",
    "handle": "millahannula",
    "followers": 24391,
    "engagement": 6.9,
    "niche": "food",
    "verified": false,
    "city": "Rääkkylä",
    "country": "Finland"
  },
  {
    "id": "020",
    "photo": "/fake-influencers/020.jpg",
    "name": "Jeanne Pelletier",
    "handle": "jeannepelletier",
    "followers": 23483,
    "engagement": 6,
    "niche": "beauty",
    "verified": false,
    "city": "Vanier",
    "country": "Canada"
  },
  {
    "id": "021",
    "photo": "/fake-influencers/021.jpg",
    "name": "Albert Murray",
    "handle": "albertdaily",
    "followers": 22067,
    "engagement": 4.4,
    "niche": "gaming",
    "verified": false,
    "city": "Dundee",
    "country": "United Kingdom"
  },
  {
    "id": "022",
    "photo": "/fake-influencers/022.jpg",
    "name": "Timothee Chevalier",
    "handle": "timotheedaily",
    "followers": 10199,
    "engagement": 6.4,
    "niche": "music",
    "verified": false,
    "city": "Bordeaux",
    "country": "France"
  },
  {
    "id": "023",
    "photo": "/fake-influencers/023.jpg",
    "name": "Åsa Erikstad",
    "handle": "asae",
    "followers": 23570,
    "engagement": 4.4,
    "niche": "tech",
    "verified": false,
    "city": "Fitjar",
    "country": "Norway"
  },
  {
    "id": "024",
    "photo": "/fake-influencers/024.jpg",
    "name": "Maya Aust",
    "handle": "maya_aust",
    "followers": 8035,
    "engagement": 7.3,
    "niche": "travel",
    "verified": false,
    "city": "Neuffen",
    "country": "Germany"
  },
  {
    "id": "025",
    "photo": "/fake-influencers/025.jpg",
    "name": "Alexis Romero",
    "handle": "alexisdaily",
    "followers": 14829,
    "engagement": 5,
    "niche": "fashion",
    "verified": true,
    "city": "Darwin",
    "country": "Australia"
  },
  {
    "id": "026",
    "photo": "/fake-influencers/026.jpg",
    "name": "Oliver Savela",
    "handle": "oliver.savela",
    "followers": 15722,
    "engagement": 6.4,
    "niche": "lifestyle",
    "verified": true,
    "city": "Kaarina",
    "country": "Finland"
  },
  {
    "id": "027",
    "photo": "/fake-influencers/027.jpg",
    "name": "Sanae Risseeuw",
    "handle": "sanae_risseeuw",
    "followers": 21179,
    "engagement": 3.7,
    "niche": "gaming",
    "verified": false,
    "city": "Kleine Huisjes",
    "country": "Netherlands"
  },
  {
    "id": "028",
    "photo": "/fake-influencers/028.jpg",
    "name": "Kenzo Dufour",
    "handle": "kenzodufour",
    "followers": 5321,
    "engagement": 7.8,
    "niche": "travel",
    "verified": false,
    "city": "Aulnay-sous-Bois",
    "country": "France"
  },
  {
    "id": "029",
    "photo": "/fake-influencers/029.jpg",
    "name": "Dylan Williamson",
    "handle": "dylanwilliamson",
    "followers": 10026,
    "engagement": 7.3,
    "niche": "fashion",
    "verified": false,
    "city": "Bath",
    "country": "United Kingdom"
  },
  {
    "id": "030",
    "photo": "/fake-influencers/030.jpg",
    "name": "Elizabeth Liu",
    "handle": "elizabeth25",
    "followers": 24220,
    "engagement": 3.8,
    "niche": "music",
    "verified": false,
    "city": "Georgetown",
    "country": "Canada"
  },
  {
    "id": "031",
    "photo": "/fake-influencers/031.jpg",
    "name": "Leah Rivera",
    "handle": "leahdaily",
    "followers": 20489,
    "engagement": 5.8,
    "niche": "music",
    "verified": false,
    "city": "Tamworth",
    "country": "Australia"
  },
  {
    "id": "032",
    "photo": "/fake-influencers/032.jpg",
    "name": "Gema Gómez",
    "handle": "thegema",
    "followers": 15097,
    "engagement": 4.6,
    "niche": "gaming",
    "verified": false,
    "city": "Albacete",
    "country": "Spain"
  },
  {
    "id": "033",
    "photo": "/fake-influencers/033.jpg",
    "name": "Simon Møller",
    "handle": "thesimon",
    "followers": 20040,
    "engagement": 7.7,
    "niche": "food",
    "verified": false,
    "city": "Sommersted",
    "country": "Denmark"
  },
  {
    "id": "034",
    "photo": "/fake-influencers/034.jpg",
    "name": "Margret Louter",
    "handle": "themargret",
    "followers": 19214,
    "engagement": 7.1,
    "niche": "music",
    "verified": false,
    "city": "Oosthuizen",
    "country": "Netherlands"
  },
  {
    "id": "035",
    "photo": "/fake-influencers/035.jpg",
    "name": "Inès Colin",
    "handle": "ines97",
    "followers": 8857,
    "engagement": 3.9,
    "niche": "fashion",
    "verified": false,
    "city": "Vitry-sur-Seine",
    "country": "France"
  },
  {
    "id": "036",
    "photo": "/fake-influencers/036.jpg",
    "name": "Harry Fletcher",
    "handle": "harrydaily",
    "followers": 21610,
    "engagement": 5.8,
    "niche": "lifestyle",
    "verified": false,
    "city": "Fermoy",
    "country": "Ireland"
  },
  {
    "id": "037",
    "photo": "/fake-influencers/037.jpg",
    "name": "Mélody Guillaume",
    "handle": "melodyg",
    "followers": 10657,
    "engagement": 5.1,
    "niche": "music",
    "verified": false,
    "city": "Le Havre",
    "country": "France"
  },
  {
    "id": "038",
    "photo": "/fake-influencers/038.jpg",
    "name": "Duane Hunt",
    "handle": "duanehunt",
    "followers": 14889,
    "engagement": 8.1,
    "niche": "music",
    "verified": false,
    "city": "Sioux Falls",
    "country": "United States"
  },
  {
    "id": "039",
    "photo": "/fake-influencers/039.jpg",
    "name": "Lucia Vega",
    "handle": "luciav",
    "followers": 12580,
    "engagement": 6.7,
    "niche": "lifestyle",
    "verified": false,
    "city": "Murcia",
    "country": "Spain"
  },
  {
    "id": "040",
    "photo": "/fake-influencers/040.jpg",
    "name": "Maëva Da Silva",
    "handle": "maevadasilva",
    "followers": 16570,
    "engagement": 4.8,
    "niche": "fitness",
    "verified": false,
    "city": "Bordeaux",
    "country": "France"
  },
  {
    "id": "041",
    "photo": "/fake-influencers/041.jpg",
    "name": "Eemeli Kokko",
    "handle": "eemelik",
    "followers": 10216,
    "engagement": 5.5,
    "niche": "food",
    "verified": false,
    "city": "Pelkosenniemi",
    "country": "Finland"
  },
  {
    "id": "042",
    "photo": "/fake-influencers/042.jpg",
    "name": "Salvatore Jentzsch",
    "handle": "salvatore_jentzsch",
    "followers": 11672,
    "engagement": 5.9,
    "niche": "fitness",
    "verified": false,
    "city": "Teublitz",
    "country": "Germany"
  },
  {
    "id": "043",
    "photo": "/fake-influencers/043.jpg",
    "name": "Hamza Mazur",
    "handle": "hamza_mazur",
    "followers": 15466,
    "engagement": 8,
    "niche": "tech",
    "verified": false,
    "city": "Borkenes",
    "country": "Norway"
  },
  {
    "id": "044",
    "photo": "/fake-influencers/044.jpg",
    "name": "Timothe Brunet",
    "handle": "timothe_brunet",
    "followers": 4758,
    "engagement": 3.5,
    "niche": "fashion",
    "verified": false,
    "city": "Boulogne-Billancourt",
    "country": "France"
  },
  {
    "id": "045",
    "photo": "/fake-influencers/045.jpg",
    "name": "Tilmann Schoch",
    "handle": "tilmanns",
    "followers": 6029,
    "engagement": 3.2,
    "niche": "music",
    "verified": false,
    "city": "Dillingen/Saar",
    "country": "Germany"
  },
  {
    "id": "046",
    "photo": "/fake-influencers/046.jpg",
    "name": "Lola Durand",
    "handle": "lola24",
    "followers": 3961,
    "engagement": 3.3,
    "niche": "music",
    "verified": false,
    "city": "Tours",
    "country": "France"
  },
  {
    "id": "047",
    "photo": "/fake-influencers/047.jpg",
    "name": "Shiva Tervoort",
    "handle": "shivat",
    "followers": 19827,
    "engagement": 6.1,
    "niche": "gaming",
    "verified": false,
    "city": "Herbaijum",
    "country": "Netherlands"
  },
  {
    "id": "048",
    "photo": "/fake-influencers/048.jpg",
    "name": "Philip White",
    "handle": "philip.white",
    "followers": 15298,
    "engagement": 6.7,
    "niche": "fitness",
    "verified": false,
    "city": "Wellington",
    "country": "Canada"
  },
  {
    "id": "049",
    "photo": "/fake-influencers/049.jpg",
    "name": "Maeva Lo",
    "handle": "maevadaily",
    "followers": 21787,
    "engagement": 7.1,
    "niche": "gaming",
    "verified": true,
    "city": "Red Rock",
    "country": "Canada"
  },
  {
    "id": "050",
    "photo": "/fake-influencers/050.jpg",
    "name": "Victor Bishop",
    "handle": "victor71",
    "followers": 12343,
    "engagement": 4,
    "niche": "fitness",
    "verified": true,
    "city": "Warrnambool",
    "country": "Australia"
  },
  {
    "id": "051",
    "photo": "/fake-influencers/051.jpg",
    "name": "Albrecht Degner",
    "handle": "albrecht.degner",
    "followers": 13197,
    "engagement": 3.6,
    "niche": "fashion",
    "verified": false,
    "city": "Drebkau",
    "country": "Germany"
  },
  {
    "id": "052",
    "photo": "/fake-influencers/052.jpg",
    "name": "Nelli Hokkanen",
    "handle": "nelli68",
    "followers": 13196,
    "engagement": 5.5,
    "niche": "fitness",
    "verified": false,
    "city": "Rautalampi",
    "country": "Finland"
  },
  {
    "id": "053",
    "photo": "/fake-influencers/053.jpg",
    "name": "Melvin Rodriguez",
    "handle": "melvin.rodriguez",
    "followers": 15750,
    "engagement": 6.2,
    "niche": "fitness",
    "verified": true,
    "city": "Colombes",
    "country": "France"
  },
  {
    "id": "054",
    "photo": "/fake-influencers/054.jpg",
    "name": "Stephanie Wade",
    "handle": "thestephanie",
    "followers": 15690,
    "engagement": 7.3,
    "niche": "food",
    "verified": false,
    "city": "Provo",
    "country": "United States"
  },
  {
    "id": "055",
    "photo": "/fake-influencers/055.jpg",
    "name": "Gitta Messer",
    "handle": "gitta.messer",
    "followers": 4509,
    "engagement": 5.1,
    "niche": "travel",
    "verified": false,
    "city": "Fürth",
    "country": "Germany"
  },
  {
    "id": "056",
    "photo": "/fake-influencers/056.jpg",
    "name": "Hugh Frazier",
    "handle": "thehugh",
    "followers": 9824,
    "engagement": 6.1,
    "niche": "fashion",
    "verified": false,
    "city": "Honolulu",
    "country": "United States"
  },
  {
    "id": "057",
    "photo": "/fake-influencers/057.jpg",
    "name": "Amélie Bourgeois",
    "handle": "amelieb",
    "followers": 21564,
    "engagement": 7.3,
    "niche": "food",
    "verified": false,
    "city": "Fort-de-France",
    "country": "France"
  },
  {
    "id": "058",
    "photo": "/fake-influencers/058.jpg",
    "name": "Rose Ruiz",
    "handle": "roser",
    "followers": 19786,
    "engagement": 4.3,
    "niche": "fashion",
    "verified": false,
    "city": "Ripon",
    "country": "United Kingdom"
  },
  {
    "id": "059",
    "photo": "/fake-influencers/059.jpg",
    "name": "Hein Van Waes",
    "handle": "heinv",
    "followers": 9376,
    "engagement": 7.7,
    "niche": "gaming",
    "verified": true,
    "city": "Lucaswolde",
    "country": "Netherlands"
  },
  {
    "id": "060",
    "photo": "/fake-influencers/060.jpg",
    "name": "Luna Bonnet",
    "handle": "theluna",
    "followers": 21689,
    "engagement": 8.1,
    "niche": "travel",
    "verified": false,
    "city": "Aulnay-sous-Bois",
    "country": "France"
  },
  {
    "id": "061",
    "photo": "/fake-influencers/061.jpg",
    "name": "Greg Brewer",
    "handle": "thegreg",
    "followers": 21664,
    "engagement": 6.8,
    "niche": "beauty",
    "verified": true,
    "city": "Kilcoole",
    "country": "Ireland"
  },
  {
    "id": "062",
    "photo": "/fake-influencers/062.jpg",
    "name": "Tristan Bergeron",
    "handle": "thetristan",
    "followers": 12904,
    "engagement": 6.3,
    "niche": "music",
    "verified": false,
    "city": "Cadillac",
    "country": "Canada"
  },
  {
    "id": "063",
    "photo": "/fake-influencers/063.jpg",
    "name": "Marilou Jean-Baptiste",
    "handle": "mariloujeanbaptiste",
    "followers": 14673,
    "engagement": 5.8,
    "niche": "music",
    "verified": false,
    "city": "Sandy Lake",
    "country": "Canada"
  },
  {
    "id": "064",
    "photo": "/fake-influencers/064.jpg",
    "name": "Tristan Tremblay",
    "handle": "tristandaily",
    "followers": 4925,
    "engagement": 4.1,
    "niche": "lifestyle",
    "verified": false,
    "city": "Killarney",
    "country": "Canada"
  },
  {
    "id": "065",
    "photo": "/fake-influencers/065.jpg",
    "name": "Edvard Eikeland",
    "handle": "theedvard",
    "followers": 9939,
    "engagement": 7.4,
    "niche": "tech",
    "verified": true,
    "city": "Sørreisa",
    "country": "Norway"
  },
  {
    "id": "066",
    "photo": "/fake-influencers/066.jpg",
    "name": "Carolus Meulenkamp",
    "handle": "carolus.meulenkamp",
    "followers": 6078,
    "engagement": 6.6,
    "niche": "fashion",
    "verified": false,
    "city": "Melissant",
    "country": "Netherlands"
  },
  {
    "id": "067",
    "photo": "/fake-influencers/067.jpg",
    "name": "Erin Webb",
    "handle": "erinwebb",
    "followers": 11629,
    "engagement": 5.7,
    "niche": "music",
    "verified": false,
    "city": "Sydney",
    "country": "Australia"
  },
  {
    "id": "068",
    "photo": "/fake-influencers/068.jpg",
    "name": "Noelia Ferrer",
    "handle": "noeliaf",
    "followers": 1780,
    "engagement": 5.9,
    "niche": "travel",
    "verified": false,
    "city": "Burgos",
    "country": "Spain"
  },
  {
    "id": "069",
    "photo": "/fake-influencers/069.jpg",
    "name": "Marius Bakkejord",
    "handle": "mariusdaily",
    "followers": 14956,
    "engagement": 7.7,
    "niche": "travel",
    "verified": false,
    "city": "Eide",
    "country": "Norway"
  },
  {
    "id": "070",
    "photo": "/fake-influencers/070.jpg",
    "name": "Justine Ma",
    "handle": "thejustine",
    "followers": 7717,
    "engagement": 5.2,
    "niche": "beauty",
    "verified": false,
    "city": "Jasper",
    "country": "Canada"
  },
  {
    "id": "071",
    "photo": "/fake-influencers/071.jpg",
    "name": "Emma Takala",
    "handle": "emma48",
    "followers": 3061,
    "engagement": 5.3,
    "niche": "music",
    "verified": false,
    "city": "Sauvo",
    "country": "Finland"
  },
  {
    "id": "072",
    "photo": "/fake-influencers/072.jpg",
    "name": "Liam Le Gall",
    "handle": "liamlegall",
    "followers": 4861,
    "engagement": 7.6,
    "niche": "fashion",
    "verified": false,
    "city": "Clermont-Ferrand",
    "country": "France"
  },
  {
    "id": "073",
    "photo": "/fake-influencers/073.jpg",
    "name": "Jared Pearson",
    "handle": "jaredp",
    "followers": 7683,
    "engagement": 3.6,
    "niche": "lifestyle",
    "verified": false,
    "city": "Charlotte",
    "country": "United States"
  },
  {
    "id": "074",
    "photo": "/fake-influencers/074.jpg",
    "name": "Nur Middelveld",
    "handle": "nurm",
    "followers": 6229,
    "engagement": 7,
    "niche": "fitness",
    "verified": false,
    "city": "Guttecoven",
    "country": "Netherlands"
  },
  {
    "id": "075",
    "photo": "/fake-influencers/075.jpg",
    "name": "Beverly Edwards",
    "handle": "beverly5",
    "followers": 15310,
    "engagement": 3.8,
    "niche": "music",
    "verified": false,
    "city": "Stamford",
    "country": "United States"
  },
  {
    "id": "076",
    "photo": "/fake-influencers/076.jpg",
    "name": "Elli Reinholdtsen",
    "handle": "ellir",
    "followers": 7305,
    "engagement": 5.2,
    "niche": "beauty",
    "verified": false,
    "city": "Skoppum",
    "country": "Norway"
  },
  {
    "id": "077",
    "photo": "/fake-influencers/077.jpg",
    "name": "Götz Sorg",
    "handle": "gotzdaily",
    "followers": 16606,
    "engagement": 3.8,
    "niche": "food",
    "verified": false,
    "city": "Hohen Neuendorf",
    "country": "Germany"
  },
  {
    "id": "078",
    "photo": "/fake-influencers/078.jpg",
    "name": "Marlene Morris",
    "handle": "marlenedaily",
    "followers": 13156,
    "engagement": 3.5,
    "niche": "fitness",
    "verified": false,
    "city": "Jersey City",
    "country": "United States"
  },
  {
    "id": "079",
    "photo": "/fake-influencers/079.jpg",
    "name": "Elias Lampinen",
    "handle": "elias.lampinen",
    "followers": 21329,
    "engagement": 4.4,
    "niche": "tech",
    "verified": false,
    "city": "Veteli",
    "country": "Finland"
  },
  {
    "id": "080",
    "photo": "/fake-influencers/080.jpg",
    "name": "Caspian Fjeldheim",
    "handle": "caspiandaily",
    "followers": 16611,
    "engagement": 6.1,
    "niche": "tech",
    "verified": false,
    "city": "Brandsøy",
    "country": "Norway"
  },
  {
    "id": "081",
    "photo": "/fake-influencers/081.jpg",
    "name": "Aatu Huhtala",
    "handle": "aatuhuhtala",
    "followers": 15956,
    "engagement": 4.4,
    "niche": "beauty",
    "verified": false,
    "city": "Enontekiö",
    "country": "Finland"
  },
  {
    "id": "082",
    "photo": "/fake-influencers/082.jpg",
    "name": "Kjell Dahlberg",
    "handle": "kjelld",
    "followers": 5149,
    "engagement": 5.2,
    "niche": "fashion",
    "verified": false,
    "city": "Årnes",
    "country": "Norway"
  },
  {
    "id": "083",
    "photo": "/fake-influencers/083.jpg",
    "name": "Annabelle Lee",
    "handle": "annabellel",
    "followers": 10626,
    "engagement": 3.9,
    "niche": "beauty",
    "verified": false,
    "city": "Otta",
    "country": "Norway"
  },
  {
    "id": "084",
    "photo": "/fake-influencers/084.jpg",
    "name": "Edgar Burns",
    "handle": "edgarburns",
    "followers": 24145,
    "engagement": 4.7,
    "niche": "lifestyle",
    "verified": false,
    "city": "Murfreesboro",
    "country": "United States"
  },
  {
    "id": "085",
    "photo": "/fake-influencers/085.jpg",
    "name": "Sharron Meyer",
    "handle": "sharron_meyer",
    "followers": 14050,
    "engagement": 6.4,
    "niche": "tech",
    "verified": false,
    "city": "Westport",
    "country": "Ireland"
  },
  {
    "id": "086",
    "photo": "/fake-influencers/086.jpg",
    "name": "Maria Lawson",
    "handle": "maria.lawson",
    "followers": 10920,
    "engagement": 4.3,
    "niche": "beauty",
    "verified": false,
    "city": "Bath",
    "country": "United Kingdom"
  },
  {
    "id": "087",
    "photo": "/fake-influencers/087.jpg",
    "name": "Lilou Blanchard",
    "handle": "liloub",
    "followers": 21044,
    "engagement": 5.7,
    "niche": "travel",
    "verified": false,
    "city": "Mulhouse",
    "country": "France"
  },
  {
    "id": "088",
    "photo": "/fake-influencers/088.jpg",
    "name": "Caroline Poulsen",
    "handle": "carolinepoulsen",
    "followers": 11466,
    "engagement": 7,
    "niche": "beauty",
    "verified": false,
    "city": "Overby Lyng",
    "country": "Denmark"
  },
  {
    "id": "089",
    "photo": "/fake-influencers/089.jpg",
    "name": "Naja Andersen",
    "handle": "naja_andersen",
    "followers": 8426,
    "engagement": 6.7,
    "niche": "music",
    "verified": false,
    "city": "Rønnede",
    "country": "Denmark"
  },
  {
    "id": "090",
    "photo": "/fake-influencers/090.jpg",
    "name": "Christian Mason",
    "handle": "christianmason",
    "followers": 3011,
    "engagement": 6,
    "niche": "music",
    "verified": false,
    "city": "Leicester",
    "country": "United Kingdom"
  },
  {
    "id": "091",
    "photo": "/fake-influencers/091.jpg",
    "name": "Kayla Kirkhus",
    "handle": "kaylak",
    "followers": 10616,
    "engagement": 4.1,
    "niche": "food",
    "verified": false,
    "city": "Seim",
    "country": "Norway"
  },
  {
    "id": "092",
    "photo": "/fake-influencers/092.jpg",
    "name": "Mason Baker",
    "handle": "masonb",
    "followers": 14352,
    "engagement": 4,
    "niche": "food",
    "verified": false,
    "city": "Belfast",
    "country": "United Kingdom"
  },
  {
    "id": "093",
    "photo": "/fake-influencers/093.jpg",
    "name": "Amber Wallace",
    "handle": "amber.wallace",
    "followers": 19971,
    "engagement": 3.9,
    "niche": "food",
    "verified": false,
    "city": "Bath",
    "country": "United Kingdom"
  },
  {
    "id": "094",
    "photo": "/fake-influencers/094.jpg",
    "name": "Jarmo Van Nieuwenhoven",
    "handle": "jarmo.vannieuwenhoven",
    "followers": 16137,
    "engagement": 4.9,
    "niche": "travel",
    "verified": false,
    "city": "Witmarsum",
    "country": "Netherlands"
  },
  {
    "id": "095",
    "photo": "/fake-influencers/095.jpg",
    "name": "Sofia Andersen",
    "handle": "sofia93",
    "followers": 23906,
    "engagement": 3.2,
    "niche": "lifestyle",
    "verified": false,
    "city": "Waterloo",
    "country": "Canada"
  },
  {
    "id": "096",
    "photo": "/fake-influencers/096.jpg",
    "name": "Carolyn Taylor",
    "handle": "carolynt",
    "followers": 12878,
    "engagement": 7.1,
    "niche": "gaming",
    "verified": false,
    "city": "Preston",
    "country": "United Kingdom"
  },
  {
    "id": "097",
    "photo": "/fake-influencers/097.jpg",
    "name": "Erich Kloth",
    "handle": "erichdaily",
    "followers": 11081,
    "engagement": 5.7,
    "niche": "tech",
    "verified": false,
    "city": "Berga/Elster",
    "country": "Germany"
  },
  {
    "id": "098",
    "photo": "/fake-influencers/098.jpg",
    "name": "Mostafa Nystrand",
    "handle": "mostafanystrand",
    "followers": 7842,
    "engagement": 6.3,
    "niche": "gaming",
    "verified": true,
    "city": "Uggdalseidet",
    "country": "Norway"
  },
  {
    "id": "099",
    "photo": "/fake-influencers/099.jpg",
    "name": "Nicole Byrd",
    "handle": "nicole47",
    "followers": 20581,
    "engagement": 6.3,
    "niche": "lifestyle",
    "verified": false,
    "city": "Geraldton",
    "country": "Australia"
  }
];
